import { useCallback, useState } from "react";

export type VisibilityProps = { isOpen: boolean; close: () => void };

export const useVisibility = (initialValue = false) => {
  const [isOpen, setIsOpen] = useState(initialValue);
  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);
  const toggle = useCallback(() => setIsOpen((open) => !open), []);
  return { isOpen, open, close, toggle };
};
